<mc-table-ng [columnSettings]="childTableSettings"
             [data]="childTableData"
             (expandCollapseEvent)="onExpandCollapseRow($event)"
             hasRowDetails="true"
             [rowDetailsTemplate]="rowDetailsTemplate">
    <ng-template let-childData #rowDetailsTemplate>
        <mc-table-ng [columnSettings]="childTableColumnSettings"
                     [data]="childData.data"
                     isChildTable="true"
                     showColumnHeaders="true">
        </mc-table-ng>
    </ng-template>
</mc-table-ng>
